import { customizeMobility } from './customize-mobility';
import {
    addGuidanceComponent,
    disposeGuidanceComponent,
    getGuidanceChatCategory,
    isGuidanceClickMode,
} from './guidance-component';
import { getCookie, removeCookie, setCookie } from './util/cookies';

const accountIds = {
    fi: '78006857-6CC0-4C9D-8654-89BE8A9E1BF8',
    dk: '3D6BF275-01F8-4DFA-8790-5D1A31C4DF61',
    no: 'D8F5A8A7-D02D-46ED-86CC-88F4F92D1DFB',
    se: '8F126DFB-3F0B-4E1B-89BC-2AD11B1944FF',
    test: '2F786A11-4288-45D8-A532-2E8C0DEEBAFC',
};

// const isAccountForDK = () => window.vngage.config.comm.accountId === accountIds.dk.toLowerCase();
// const isAccountForFI = () => window.vngage.config.comm.accountId === accountIds.fi.toLowerCase();
// const isAccountForNO = () => window.vngage.config.comm.accountId === accountIds.no.toLowerCase();
const isAccountForSE = () => window.vngage.config.comm.accountId === accountIds.se.toLowerCase();
const isAccountForTest = () =>
    window.vngage.config.comm.accountId === accountIds.test.toLowerCase();

const checkBannerId = (banner) =>
    window.vngage.solutionIds && window.vngage.solutionIds.includes(banner.config.id);

const getChatState = () => {
    if (!window.vngage) return '';
    try {
        const state = localStorage.getItem('vngage_' + window.vngage.config.comm.accountId);
        const chatState = JSON.parse(state);
        return chatState?.user?.state || '';
    } catch (e) {
        // Nothing
    }
    return '';
};

const isChatActive = () => getChatState() === 'InDialog';
const isChatCompleted = () => getChatState() === 'Completed';

const updateCustomerIdentity = () => {
    const updateIdentity = () => {
        if (window.ifhelp2015api.updateDEChatIdentity) {
            window.ifhelp2015api.updateDEChatIdentity();
        }
    };

    window.vngage.subscribe('app.initialized', () => updateIdentity());

    window.vngage.subscribe('chat.initialized', () => updateIdentity());

    window.vngage.subscribe('session_id_changed', () => updateIdentity());
};

const subscribeToConversationClosed = (func) => {
    // There seems to be a bug in the conversation_closed event. It triggers twice.
    // window.vngage.subscribe('conversation_closed', () => {
    window.vngage.subscribe('stream.addConversationEvents', (e, t) => {
        if (
            t &&
            t.events &&
            t.events.length &&
            t.events[0].data &&
            t.events[0].data.type === 'conversationClosed'
        ) {
            func();
        }
    });
};

let trackingStatus = {
    chatStatusHandled: false,
    panelCollapsedHandled: false,
    category: undefined,
    bannerIntroHandled: [],
};

const trackingStatusKey = 'chat-tracking-status';
const saveTrackingStatus = () => {
    if (isGuidanceClickMode()) return;
    setCookie(trackingStatusKey, JSON.stringify(trackingStatus));
};
const restoreTrackingStatus = () => {
    if (!isChatActive()) return;
    const savedStatus = getCookie(trackingStatusKey);
    if (!savedStatus) return;
    try {
        trackingStatus = JSON.parse(savedStatus);
    } catch {
        // nothing
    }
};

const getBannerCategory = (banner) =>
    banner ? `${banner.config.bannerId}, ${banner.config.name}` : undefined;
const getCategory = (banner) =>
    getGuidanceChatCategory() || getBannerCategory(banner) || trackingStatus.category;

const pushChatStartedEvent = () => {
    if (window.NordicTracking && !isGuidanceClickMode()) {
        window.NordicTracking.setCategory(getCategory());
        window.NordicTracking.eventStartChat();
        window.NordicTracking.eventChatConversationStarted();
    }
};

const updateDataLayer = () => {
    window.vngage.subscribe('banner:created', (eventName, banner) => {
        if (!window.NordicTracking || !checkBannerId(banner)) return;
        if (banner.config.status.isOpen) {
            window.NordicTracking.panel().setFunction(
                window.NordicTracking.PANELINFO_FUNCTION_NAME_CHAT,
                window.NordicTracking.PANELINFO_FUNCTION_STATUS_AVAILABLE
            );
        } else if (banner.config.status.isBusy) {
            window.NordicTracking.panel().setFunction(
                window.NordicTracking.PANELINFO_FUNCTION_NAME_CHAT,
                window.NordicTracking.PANELINFO_FUNCTION_STATUS_BUSY
            );
        } else {
            window.NordicTracking.panel().setFunction(
                window.NordicTracking.PANELINFO_FUNCTION_NAME_CHAT,
                window.NordicTracking.PANELINFO_FUNCTION_STATUS_CLOSED
            );
        }
        if (!trackingStatus.panelCollapsedHandled) {
            trackingStatus.panelCollapsedHandled = true;
            window.NordicTracking.eventPanelLoaded(
                window.NordicTracking.PANELINFO_STATUS_COLLAPSED
            );
        }
    });

    window.vngage.subscribe('chat.initialized', pushChatStartedEvent);
    window.addEventListener('guidance.chat.started', pushChatStartedEvent);

    window.vngage.subscribe('chat.initialized', saveTrackingStatus);
    window.addEventListener('guidance.chat.started', saveTrackingStatus);

    subscribeToConversationClosed(() => {
        if (window.NordicTracking && !isGuidanceClickMode()) {
            window.NordicTracking.setCategory(getCategory());
            window.NordicTracking.eventChatEnded();
        }
    });

    window.vngage.subscribe('dialog:close', disposeGuidanceComponent);

    const pushChatStatusEvent = (banner, proactive) => {
        window.NordicTracking.setCategory(getCategory(banner));

        if (banner.config.status.isOpen) {
            window.NordicTracking.eventChatOpen(proactive);
        } else if (banner.config.status.isBusy) {
            window.NordicTracking.eventChatBusy(proactive);
        } else {
            window.NordicTracking.eventChatClosed(proactive);
        }
    };

    window.vngage.subscribe('banner:show', (eventName, banner) => {
        trackingStatus.category = getBannerCategory(banner);
        if (!window.NordicTracking || !checkBannerId(banner) || trackingStatus.chatStatusHandled)
            return;
        const chatIcon = document.getElementById('chat-menu-button');
        if (!chatIcon) return;
        chatIcon.addEventListener('click', () => {
            pushChatStatusEvent(banner, false);
        });
        chatIcon.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                pushChatStatusEvent(banner, false);
            }
        });
        trackingStatus.chatStatusHandled = true;
    });

    const skipBannerIntroHandling = (banner) => {
        if (!trackingStatus.bannerIntroHandled.includes(banner.config.id)) {
            trackingStatus.bannerIntroHandled.push(banner.config.id);
            return false;
        }
        return true;
    };

    const shownBannerIdKey = 'vngage-shown-banner-id';

    const isShownBannerIntro = (banner) => {
        return getCookie(shownBannerIdKey) === banner.config.bannerId;
    };

    const afterBannerIntroShow = (banner) => {
        pushChatStatusEvent(banner, true);
        setCookie(shownBannerIdKey, banner.config.bannerId);
    };

    const afterBannerIntroHide = (banner) => {
        const tracking = window.NordicTracking;
        tracking.setCategory(getCategory(banner));
        tracking.eventClosePanel(true, tracking.PANELINFO_FUNCTION_NAME_CHAT);
    };

    const isFinnishCommercial = () => {
        const page = window.location.href;
        return (
            /yritys\.if\.fi/.test(page) ||
            /if\.fi\/yritysasiakkaat/.test(page) ||
            /if\.fi\/en\/commercial/.test(page)
        );
    };

    window.vngage.subscribe('banner:show', (eventName, banner) => {
        const tracking = window.NordicTracking;
        if (!tracking || !checkBannerId(banner)) return;
        const introDelay = banner.config.introDelay || (isFinnishCommercial() ? 5 : 0);
        const introDuration = banner.config.introDuration || (isFinnishCommercial() ? 20 : 0);
        if (skipBannerIntroHandling(banner) || isShownBannerIntro(banner)) {
            if (introDelay) banner.hide();
            return;
        }
        if (introDelay && introDuration) {
            banner.intro(
                introDelay,
                introDuration,
                () => afterBannerIntroShow(banner),
                () => afterBannerIntroHide(banner)
            );
        } else if (introDelay) {
            banner.expand(introDelay, () => afterBannerIntroShow(banner));
        }
    });

    window.vngage.subscribe('banner:show', (eventName, banner) => {
        const tracking = window.NordicTracking;
        if (!tracking || !checkBannerId(banner)) return;
        const closeButton = document.querySelector('#' + banner.el.id + ' .vngage-close-btn');
        if (closeButton) {
            if (closeButton.getAttribute('data-tracked')) return;
            closeButton.addEventListener('click', () => {
                tracking.setCategory(getCategory(banner));
                tracking.eventClosePanel(false, tracking.PANELINFO_FUNCTION_NAME_CHAT);
            });
            closeButton.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    tracking.setCategory(getCategory(banner));
                    tracking.eventClosePanel(false, tracking.PANELINFO_FUNCTION_NAME_CHAT);
                }
            });
            closeButton.setAttribute('data-tracked', 'true');
        }
    });

    restoreTrackingStatus();
};

const updateMobilityContent = () => {
    if (!isAccountForSE() && !isAccountForTest()) return;

    customizeMobility();
};

const activeChatReason = 'active-chat';

const addContactPanelTogglingLogic = () => {
    if (isChatActive()) {
        window.dispatchEvent(new CustomEvent('addHidePanelReason', { detail: activeChatReason }));
    } else {
        window.dispatchEvent(
            new CustomEvent('removeHidePanelReason', { detail: activeChatReason })
        );
    }

    window.vngage.subscribe('conversation_started', () => {
        window.dispatchEvent(new CustomEvent('addHidePanelReason', { detail: activeChatReason }));
    });

    window.vngage.subscribe('queue:joined', () => {
        window.dispatchEvent(new CustomEvent('addHidePanelReason', { detail: activeChatReason }));
    });

    window.vngage.subscribe('dialog:close', () => {
        window.dispatchEvent(
            new CustomEvent('removeHidePanelReason', { detail: activeChatReason })
        );
    });

    window.vngage.subscribe('conversation_resumed', () => {
        window.dispatchEvent(new CustomEvent('addHidePanelReason', { detail: activeChatReason }));
    });
};

let surveyObserver = null;

const addCloseButton = () => {
    const assignCloseButtonStyle = (closeButton) => {
        const style = {
            position: 'absolute',
            top: '15px',
            right: '12px',
            bottom: 'auto',
            left: 'auto',
            zIndex: 101,
            cursor: 'pointer',
            backgroundColor: 'transparent',
            backgroundImage:
                'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjQnIGhlaWdodD0nMjQnIHZpZXdCb3g9JzAgMCAyNCAyNCcgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48ZyBjbGlwLXBhdGg9J3VybCgjY2xpcDBfNDA0XzE0KSc+PHBhdGggZD0nTTE5IDVMNSAxOU0xOSAxOUw1IDUnIHN0cm9rZT0nIzMzMUUxMScgc3Ryb2tlLXdpZHRoPScxLjUnIHN0cm9rZS1taXRlcmxpbWl0PScxMCcgc3Ryb2tlLWxpbmVjYXA9J3NxdWFyZScvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9J2NsaXAwXzQwNF8xNCc+PHJlY3Qgd2lkdGg9JzI0JyBoZWlnaHQ9JzI0JyBmaWxsPSd3aGl0ZScvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPgo=")',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            // backgroundSize: 'cover',
            width: '20px',
            height: '20px',
            border: 'none',
            margin: 0,
            padding: 0,
        };
        Object.assign(closeButton.style, style);
    };

    const showOrHideCloseSurveyButton = () => {
        const closeButton = document.querySelector('.close-chat-button');
        if (!closeButton) return;

        const survey = document.querySelector('.my-container');
        if (survey) {
            closeButton.classList.add('close-survey');
            closeButton.style.display = 'block';
            closeButton.ariaLabel = 'Close survey';
            return;
        }

        if (closeButton.classList.contains('close-survey')) {
            closeButton.classList.remove('close-survey');
            closeButton.ariaLabel = 'Close chat';
        }
    };

    const observeSurveyChanges = () => {
        if (surveyObserver) return;
        const panelBody = document.querySelector('.vngage-panel-body');
        if (!panelBody) return;

        const config = { childList: true };
        const callback = (mutationList /*, observer*/) => {
            if (mutationList.length > 0) {
                showOrHideCloseSurveyButton();
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(panelBody, config);
        surveyObserver = observer;
    };

    const getClosePanelButton = () =>
        document.querySelector('.dialog-completedmessage a.menubutton.vngage-btn.btn-leave');

    const closeSurvey = () => {
        const survey = document.querySelector('.my-container');
        if (survey) {
            survey.remove();
            return true;
        }
        return false;
    };

    const closeConversation = () => {
        const closePanelButton = getClosePanelButton();
        if (closePanelButton) return false;

        window.vngage.leave();
        return true;
    };

    const closeChatPanel = () => {
        const closePanelButton = getClosePanelButton();
        if (!closePanelButton) return false;

        const event = document.createEvent('UIEvent');
        event.initUIEvent('touchend', true, true); // deprecated but Safari doesn't support TouchEvent API
        event.changedTouches = [
            {
                pageX: 1,
                pageY: 1,
            },
        ];
        closePanelButton.dispatchEvent(event);
        closePanelButton.click();
        return true;
    };

    const clickCloseButton = () => {
        closeSurvey() || closeConversation() || closeChatPanel();
    };

    const hideMenuButton = () => {
        if (document.querySelector('style[chat]')) return;
        const style = document.createElement('style');
        style.setAttribute('chat', '');
        style.innerHTML =
            '.vngage-icon-menu.vngage-panel-menu-button { display: none !important; }';
        document.head.appendChild(style);
    };

    const showCloseButton = () => {
        const menuButton = document.querySelector('.vngage-icon-menu.vngage-panel-menu-button');
        if (!menuButton) return;

        const panelBody = document.querySelector('.vngage-panel-body');
        if (!panelBody) return;

        hideMenuButton();

        if (document.querySelector('.close-chat-button')) return;

        const closeButton = document.createElement('div');
        closeButton.classList.add('vngage-btn');
        closeButton.classList.add('btn-leave');
        closeButton.classList.add('close-chat-button');
        assignCloseButtonStyle(closeButton);
        closeButton.role = 'button';
        closeButton.tabIndex = 0;
        closeButton.ariaLabel = 'Close chat';
        panelBody.parentElement.insertBefore(closeButton, panelBody);
        closeButton.addEventListener('click', () => {
            clickCloseButton();
        });
        closeButton.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                clickCloseButton();
            }
        });
    };

    const showCloseChatOrSurveyButton = () => {
        showCloseButton();
        observeSurveyChanges();
    };

    window.vngage.subscribe('chat.initialized', () => {
        setTimeout(showCloseChatOrSurveyButton, 200);
        const panelHeader = document.querySelector('.vngage-panel-header');
        if (panelHeader) {
            panelHeader.addEventListener('click', () => {
                setTimeout(showCloseChatOrSurveyButton, 100);
            });
        }
    });

    if (isChatActive()) setTimeout(showCloseChatOrSurveyButton, 2000);

    window.vngage.subscribe('close', () => {
        if (surveyObserver) {
            surveyObserver.disconnect();
            surveyObserver = null;
        }
        const style = document.querySelector('style[chat]');
        if (style) style.remove();
    });
};

const addLanguageParameterToUrl = () => {
    window.vngage.subscribe('queue:joined', () => {
        const url = new URL(window.location.href);
        const key = 'lang';
        let lang = url.searchParams.get(key);
        if (lang) return;

        lang = document.documentElement.lang;
        url.searchParams.set(key, lang);

        window.vngage.setClaims({ originUrl: url.toString() });
    });
};

const loadForstaFeedbackSurvey = () => {
    // These are used by Forsta CX survey
    window.vngage.getCookie = getCookie;
    window.vngage.setCookie = setCookie;
    window.vngage.removeCookie = removeCookie;

    const isCommercial = () => {
        const page = window.location.href;
        return (
            /if\.fi\/yritysasiakkaat/.test(page) ||
            /if\.fi\/en\/commercial/.test(page) ||
            /yritys\.if\.fi/.test(page)
        );
    };
    const getProgramKey = () => (isCommercial() ? 'mXInTB' : 'sLsnXK');

    setTimeout(() => {
        const programKey = getProgramKey();
        const script = document.createElement('script');
        script.async = true;
        script.src =
            'https://digitalfeedback.euro.confirmit.com/api/digitalfeedback/loader?programKey=' +
            programKey;
        script.id = 'cf-program-' + programKey;
        document.body.appendChild(script);
    }, 3000);
};

const loadSurvey = () => {
    loadForstaFeedbackSurvey();
};

const logMissingIdentity = () => {
    window.vngage.subscribe('chat.initialized', () => {
        const sessionStorage = window.sessionStorage;
        if (!sessionStorage || !sessionStorage.getItem('identity-chat')) return;

        const updatedId = sessionStorage.getItem('updated-chat');
        const sessionId = window.vngage.vngageSessionId();
        if (sessionId && sessionId === updatedId) return;

        window.ifhelp2015api.logEvent({
            title: 'Chat initialized without identity',
            url: window.location.href,
            sessionId: sessionId,
            updatedId: updatedId,
            started: sessionStorage.getItem('identity-started'),
            requested: sessionStorage.getItem('identity-requested'),
            succeeded: sessionStorage.getItem('identity-succeeded'),
            failed: sessionStorage.getItem('identity-failed'),
        });
    });
};

const listenToSubmitClicks = () => {
    if (!isAccountForTest()) return;

    const isVisible = (el) => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    const submitButtons = [...document.querySelectorAll('input[type="submit"]')].filter(isVisible);

    submitButtons.forEach((button) =>
        button.addEventListener('click', () => window.vngage.evaluateOpportunities())
    );
};

const updateHelpers = () => {
    window.vngage.isChatActive = isChatActive;
    window.vngage.isChatCompleted = isChatCompleted;
};

const disableButtonsAfterChatCloses = () => {
    subscribeToConversationClosed(() => {
        document
            .querySelectorAll('button.vngage-btn')
            .forEach((elem) => elem.setAttribute('disabled', 'true'));
    });
};

const setChatAppTypeToClaims = () => {
    const chatAppTypeKey = 'chat-app-type';
    const getChatAppType = () => getCookie(chatAppTypeKey);
    const removeChatAppType = () => removeCookie(chatAppTypeKey);
    const setChatAppType = (chatAppType) => {
        setCookie(chatAppTypeKey, chatAppType);
        window.vngage.setClaims({ 'Digital application': chatAppType });
    };
    window.vngage.setChatAppType = setChatAppType;

    window.vngage.subscribe('participant_joined', (e, action) => {
        const joinedUserId = action?.action?.participant?.[0].participant?.userId;
        if (!joinedUserId) return;
        const chatAppType = getChatAppType();
        if (window.botUsers?.indexOf(joinedUserId) >= 0) {
            setChatAppType(chatAppType || 'Chatbot');
        } else {
            setChatAppType(chatAppType || 'Direct human chat');
        }
    });

    window.vngage.subscribe('dialog:close', removeChatAppType);
};

const customizeChat = () => {
    updateHelpers();
    updateCustomerIdentity();
    updateDataLayer();
    updateMobilityContent();
    addContactPanelTogglingLogic();
    addCloseButton();
    addLanguageParameterToUrl();
    addGuidanceComponent();
    loadSurvey();
    logMissingIdentity();
    listenToSubmitClicks();
    disableButtonsAfterChatCloses();
    setChatAppTypeToClaims();
};

export { customizeChat };
